import React from "react";
import { Box, Container, Grid, Typography, Link, IconButton, Divider } from "@mui/material";
import { Facebook, Instagram, Twitter, LinkedIn, Email, Phone, LocationOn } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import logo from "../../Assets/logo.png";

const PublicFooter = () => {
  return (
    <Box
      component="footer"
      sx={{
        background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
        color: "white",
        position: "relative",
        overflow: "hidden",
        width: "100%",
        maxWidth: "100vw",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "100%",
          background:
            "radial-gradient(circle at 20% 80%, rgba(243, 111, 33, 0.1) 0%, transparent 50%)",
          pointerEvents: "none",
        },
      }}
    >
      {/* Wave decoration */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          overflow: "hidden",
          lineHeight: 0,
          transform: "rotate(180deg)",
        }}
      >
        <svg
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          style={{ width: "100%", height: "60px" }}
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            fill="rgba(245, 247, 250, 0.3)"
          />
        </svg>
      </Box>

      <Container 
        maxWidth="lg" 
        sx={{ 
          position: "relative", 
          zIndex: 1, 
          pt: { xs: 8, md: 10 }, 
          pb: { xs: 3, md: 4 },
          px: { xs: 2, sm: 3, md: 4 }
        }}
      >
        <Grid container spacing={{ xs: 3, sm: 4 }}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: { xs: 2, md: 3 } }}>
              <Box
                component={RouterLink}
                to="/"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: 1.5, sm: 2 },
                  textDecoration: "none",
                  mb: 2,
                  justifyContent: { xs: "center", md: "flex-start" },
                }}
              >
                <Box
                  component="img"
                  src={logo}
                  alt="Logo"
                  sx={{
                    height: { xs: 40, sm: 50 },
                    filter: "brightness(0) invert(1) drop-shadow(0 2px 8px rgba(255,255,255,0.3))",
                  }}
                />
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: "1.25rem", sm: "1.5rem" },
                    background: "linear-gradient(135deg, #ffffff 0%, #ffe0b2 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                >
                  ريستو كاش
                </Typography>
              </Box>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: "grey.400", 
                  mb: 3, 
                  lineHeight: 1.8,
                  textAlign: { xs: "center", md: "right" },
                  fontSize: { xs: "0.875rem", sm: "0.9rem" }
                }}
              >
                نحن نقدم أفضل الحلول التقنية لإدارة المطاعم والكافيهات مع التزام كامل بالجودة والاحترافية.
              </Typography>
              <Box sx={{ 
                display: "flex", 
                flexDirection: "column", 
                gap: 1.5,
                alignItems: { xs: "center", md: "flex-start" }
              }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Email sx={{ fontSize: { xs: 16, sm: 18 }, color: "#f36f21" }} />
                  <Typography variant="body2" sx={{ color: "grey.400", fontSize: { xs: "0.8rem", sm: "0.875rem" } }}>
                    info@restocash.com
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Phone sx={{ fontSize: { xs: 16, sm: 18 }, color: "#f36f21" }} />
                  <Typography variant="body2" sx={{ color: "grey.400", fontSize: { xs: "0.8rem", sm: "0.875rem" } }}>
                    +966 50 123 4567
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <LocationOn sx={{ fontSize: { xs: 16, sm: 18 }, color: "#f36f21" }} />
                  <Typography variant="body2" sx={{ color: "grey.400", fontSize: { xs: "0.8rem", sm: "0.875rem" } }}>
                    البحيرة، جمهورية مصر العربية
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={6} sm={4} md={2.5}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                fontWeight: 700,
                mb: 2,
                fontSize: { xs: "1rem", sm: "1.25rem" },
                position: "relative",
                textAlign: { xs: "center", md: "right" },
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: -8,
                  right: { xs: "50%", md: 0 },
                  transform: { xs: "translateX(50%)", md: "none" },
                  width: 40,
                  height: 3,
                  background: "linear-gradient(90deg, #f36f21, #e65100)",
                  borderRadius: 2,
                },
              }}
            >
              روابط سريعة
            </Typography>
            <Box sx={{ 
              display: "flex", 
              flexDirection: "column", 
              gap: { xs: 1, sm: 1.5 }, 
              mt: 3,
              alignItems: { xs: "center", md: "flex-start" }
            }}>
              <Link
                component={RouterLink}
                to="/"
                underline="none"
                sx={{
                  color: "grey.400",
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                  transition: "all 0.3s",
                  "&:hover": {
                    color: "white",
                    transform: "translateX(-5px)",
                  },
                }}
              >
                ← الرئيسية
              </Link>
              <Link
                component={RouterLink}
                to="/about-app"
                underline="none"
                sx={{
                  color: "grey.400",
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                  transition: "all 0.3s",
                  "&:hover": {
                    color: "white",
                    transform: "translateX(-5px)",
                  },
                }}
              >
                ← عن التطبيق
              </Link>
              <Link
                component={RouterLink}
                to="/contact-us"
                underline="none"
                sx={{
                  color: "grey.400",
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                  transition: "all 0.3s",
                  "&:hover": {
                    color: "white",
                    transform: "translateX(-5px)",
                  },
                }}
              >
                ← تواصل معنا
              </Link>
              <Link
                component={RouterLink}
                to="/login"
                underline="none"
                sx={{
                  color: "grey.400",
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                  transition: "all 0.3s",
                  "&:hover": {
                    color: "white",
                    transform: "translateX(-5px)",
                  },
                }}
              >
                ← تسجيل الدخول
              </Link>
            </Box>
          </Grid>

          {/* Services */}
          <Grid item xs={6} sm={4} md={2.5}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                fontWeight: 700,
                mb: 2,
                fontSize: { xs: "1rem", sm: "1.25rem" },
                position: "relative",
                textAlign: { xs: "center", md: "right" },
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: -8,
                  right: { xs: "50%", md: 0 },
                  transform: { xs: "translateX(50%)", md: "none" },
                  width: 40,
                  height: 3,
                  background: "linear-gradient(90deg, #f36f21, #e65100)",
                  borderRadius: 2,
                },
              }}
            >
              خدماتنا
            </Typography>
            <Box sx={{ 
              display: "flex", 
              flexDirection: "column", 
              gap: { xs: 1, sm: 1.5 }, 
              mt: 3,
              alignItems: { xs: "center", md: "flex-start" }
            }}>
              <Typography variant="body2" sx={{ color: "grey.400", fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                • إدارة الطلبات
              </Typography>
              <Typography variant="body2" sx={{ color: "grey.400", fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                • نظام نقاط البيع
              </Typography>
              <Typography variant="body2" sx={{ color: "grey.400", fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                • التقارير والإحصائيات
              </Typography>
              <Typography variant="body2" sx={{ color: "grey.400", fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                • إدارة المخزون
              </Typography>
            </Box>
          </Grid>

          {/* Social Media */}
          <Grid item xs={12} sm={12} md={3}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                fontWeight: 700,
                mb: 2,
                fontSize: { xs: "1rem", sm: "1.25rem" },
                position: "relative",
                textAlign: { xs: "center", md: "right" },
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: -8,
                  right: { xs: "50%", md: 0 },
                  transform: { xs: "translateX(50%)", md: "none" },
                  width: 40,
                  height: 3,
                  background: "linear-gradient(90deg, #f36f21, #e65100)",
                  borderRadius: 2,
                },
              }}
            >
              تابعنا
            </Typography>
            <Box sx={{ 
              display: "flex", 
              gap: 1.5, 
              mt: 3, 
              flexWrap: "wrap",
              justifyContent: { xs: "center", md: "flex-start" }
            }}>
              <IconButton
                href="#"
                sx={{
                  background: "rgba(255,255,255,0.05)",
                  color: "white",
                  transition: "all 0.3s",
                  "&:hover": {
                    background: "#1877F2",
                    transform: "translateY(-5px)",
                    boxShadow: "0 8px 20px rgba(24, 119, 242, 0.4)",
                  },
                }}
              >
                <Facebook />
              </IconButton>
              <IconButton
                href="#"
                sx={{
                  background: "rgba(255,255,255,0.05)",
                  color: "white",
                  transition: "all 0.3s",
                  "&:hover": {
                    background: "linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)",
                    transform: "translateY(-5px)",
                    boxShadow: "0 8px 20px rgba(228, 64, 95, 0.4)",
                  },
                }}
              >
                <Instagram />
              </IconButton>
              <IconButton
                href="#"
                sx={{
                  background: "rgba(255,255,255,0.05)",
                  color: "white",
                  transition: "all 0.3s",
                  "&:hover": {
                    background: "#1DA1F2",
                    transform: "translateY(-5px)",
                    boxShadow: "0 8px 20px rgba(29, 161, 242, 0.4)",
                  },
                }}
              >
                <Twitter />
              </IconButton>
              <IconButton
                href="#"
                sx={{
                  background: "rgba(255,255,255,0.05)",
                  color: "white",
                  transition: "all 0.3s",
                  "&:hover": {
                    background: "#0077B5",
                    transform: "translateY(-5px)",
                    boxShadow: "0 8px 20px rgba(0, 119, 181, 0.4)",
                  },
                }}
              >
                <LinkedIn />
              </IconButton>
            </Box>
            <Typography 
              variant="body2" 
              sx={{ 
                color: "grey.500", 
                mt: 3, 
                lineHeight: 1.7,
                textAlign: { xs: "center", md: "right" },
                fontSize: { xs: "0.8rem", sm: "0.875rem" }
              }}
            >
              تابعنا على وسائل التواصل الاجتماعي لتبقى على اطلاع بآخر الأخبار والتحديثات
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: { xs: 3, md: 4 }, borderColor: "rgba(255,255,255,0.1)" }} />

        {/* Bottom Bar */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: { xs: 2, sm: 1 },
            textAlign: "center",
          }}
        >
          <Typography 
            variant="body2" 
            sx={{ 
              color: "grey.500",
              fontSize: { xs: "0.75rem", sm: "0.875rem" }
            }}
          >
            © {new Date().getFullYear()} ريستو كاش. جميع الحقوق محفوظة
          </Typography>
          <Box sx={{ 
            display: "flex", 
            gap: { xs: 2, sm: 3 },
            flexWrap: "wrap",
            justifyContent: "center"
          }}>
            <Link
              href="#"
              underline="none"
              sx={{
                color: "grey.500",
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                transition: "color 0.3s",
                "&:hover": { color: "white" },
              }}
            >
              سياسة الخصوصية
            </Link>
            <Link
              href="#"
              underline="none"
              sx={{
                color: "grey.500",
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                transition: "color 0.3s",
                "&:hover": { color: "white" },
              }}
            >
              الشروط والأحكام
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default PublicFooter;
